import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'

import AutoFocus from '../../AutoFocus'
import buttonStyle from 'Styles/button.css'

import style from './style.css'

import closeImg from 'Assets/x-icon-white.svg'

function closeButton () {
  return (
    <img
      src={closeImg}
      alt="Close question value info"
      className={style.closeIcon}
    />
  )
}

export default function QuestionValue (props) {
  const showAnswer = 'No credit is given for questions that you do not answer.'
  const hintOrWrong = 'The value of this question has been reduced because of hints taken and/or incorrect attempts.'
  const standard = 'Question value varies by difficulty level and goes down when you take hints or answer incorrectly.'

  const copy = props.showAnswer ? showAnswer : (props.hintOrIncorrect ? hintOrWrong : standard)
  const { lessThan } = props.browser
  const previewSpacer = props.isPreview ? style.previewSpacer : ''

  return (
    <div className={classnames(style.scoreInfo, previewSpacer)}>
      <button
        className={classnames(buttonStyle.rectangle, style.hideInfo)}
        onClick={props.onClick}
      >
        {lessThan.medium ? closeButton() : 'Hide Tip'}
      </button>
      <AutoFocus>
        {copy}
      </AutoFocus>
    </div>
  )
}

QuestionValue.propTypes = {
  browser: PropTypes.object.isRequired,
  onClick: PropTypes.func.isRequired,
  hintOrIncorrect: PropTypes.bool.isRequired,
  showAnswer: PropTypes.bool.isRequired,
  isPreview: PropTypes.bool.isRequired
}
